export default {
  MH: {},
  RJ: {},
  UP: {},
  MP: {},
  GJ: {},
  BH: {},
};
